import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { COMPANY } from '../../utils/constants';

const GW_LINKS = [
  { icon: '📋', label: 'PolicyCenter'     },
  { icon: '💳', label: 'BillingCenter'    },
  { icon: '🛡️', label: 'ClaimCenter'      },
  { icon: '☁️', label: 'Cloud Migration'  },
  { icon: '🎨', label: 'Jutro / JDP'      },
  { icon: '💻', label: 'Digital Products' },
  { icon: '⬆️', label: 'Upgrades & IGApps'},
];
const MW_LINKS = [
  { icon: '🤖', label: 'Android Apps'        },
  { icon: '🍎', label: 'iOS Apps'             },
  { icon: '🌐', label: 'Web Applications'     },
  { icon: '📱', label: 'App Store Publishing' },
];
import { ProteconsLogo } from '../../assets/icons/SocialIcons';
import SocialLinks from '../common/SocialLinks';
import './Footer.css';

const OFFICES = [
  {
    type: 'Regd. Office',
    city: 'Bareilly',
    lines: ['Swastik Towers, CP-17/18, Mahanagar', 'Pilibhit Bypass Road', 'Bareilly, Uttar Pradesh – 243005, India'],
  },
  {
    type: 'Branch Office',
    city: 'Bangalore',
    lines: ['VO-363 Block L, Embassy Tech Village', 'Outer Ring Road, Bellandur', 'Bengaluru, Karnataka – 560103, India'],
  },
];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  // Clicking a same-page anchor Link is a no-op in React Router when the
  // target URL matches the current one, so repeat clicks to the same
  // section (e.g. two footer links both pointing to #guidewire) silently
  // fail. Scroll directly when already on /services; otherwise navigate.
  const goToSection = (hash) => (e) => {
    e.preventDefault();
    if (location.pathname === '/services') {
      document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate(`/services${hash}`);
    }
  };

  return (
    <footer className="footer">
      {/* Top accent line */}
      <div className="footer__accent" />

      <div className="container">
        {/* ── Main grid ── */}
        <div className="footer__grid">

          {/* Brand */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <ProteconsLogo size={72} />
            </Link>
            <p className="footer__desc">
              Niche Guidewire specialist with 50+ certified ProtecoNINs delivering
              insurance technology solutions globally.
            </p>
            <SocialLinks size={32} />
          </div>

          {/* Services */}
          <div className="footer__col">
            <h4 className="footer__heading">Services</h4>

            <span className="footer__group-label">Guidewire InsuranceSuite</span>
            {GW_LINKS.map(({ icon, label }) => (
              <Link
                key={label}
                to="/services#guidewire"
                onClick={goToSection('#guidewire')}
                className="footer__link footer__link--icon"
              >
                <span className="footer__link-icon">{icon}</span>{label}
              </Link>
            ))}

            <span className="footer__group-label footer__group-label--mt">Mobile &amp; Web</span>
            {MW_LINKS.map(({ icon, label }) => (
              <Link
                key={label}
                to="/services#mobile-web"
                onClick={goToSection('#mobile-web')}
                className="footer__link footer__link--icon"
              >
                <span className="footer__link-icon">{icon}</span>{label}
              </Link>
            ))}
          </div>

          {/* Products */}
          <div className="footer__col">
            <h4 className="footer__heading">Products</h4>
            <Link to="/product-development"  className="footer__link">🏗️ AMS Suite</Link>
            <Link to="/cloud-kitchen"        className="footer__link">☁️ Cloud Kitchen</Link>
            <Link to="/tracking-smart-city"  className="footer__link">🏙️ Smart City Tracking</Link>
            <Link to="/collection-management"   className="footer__link">📲 Collection Management</Link>
          </div>

          {/* Company */}
          <div className="footer__col">
            <h4 className="footer__heading">Company</h4>
            <Link to="/about"        className="footer__link">About Us</Link>
            <Link to="/team"         className="footer__link">Our Team</Link>
            <Link to="/events"       className="footer__link">Events</Link>
            <Link to="/publications" className="footer__link">Publications</Link>
            <Link to="/global-reach" className="footer__link">Global Reach</Link>
            <Link to="/careers"      className="footer__link">Careers</Link>
            <Link to="/contact"      className="footer__link">Contact</Link>
          </div>

          {/* Offices */}
          <div className="footer__col">
            <h4 className="footer__heading">Our Offices</h4>
            {OFFICES.map((o) => (
              <div key={o.city} className="footer__office">
                <div className="footer__office-header">
                  <span className="footer__office-dot" />
                  <span className="footer__office-label">{o.type} · {o.city}</span>
                </div>
                <address className="footer__office-addr">
                  {o.lines.map((l, i) => <span key={i}>{l}</span>)}
                </address>
              </div>
            ))}
          </div>

        </div>

        {/* ── Bottom bar ── */}
        <div className="footer__bottom">
          <p className="footer__copyright">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
            <span className="footer__cin">CIN: {COMPANY.cin}</span>
          </p>
          <div className="footer__legal">
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy', 'Sitemap'].map((item) => (
              <span key={item} className="footer__legal-link">{item}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
